import { createContext } from 'react';

let defaultVal:any = {};
export default createContext(defaultVal);
